import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
// import { Select, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
// import { useLabelContext } from "../../../Context";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import { Typography, message, Image } from "antd";
import { FileOutlined, AudioOutlined } from "@ant-design/icons";
import { Footer } from "../footer/footer";

const { Text } = Typography;

const ViewTask = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const task = location.state?.task;

  console.log(navigate, task, "tasksssssssssssssssssssss");
  const relId = task?.id;
  const relType = "task";

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  //   const [downloadingId, setDownloadingId] = useState(null);

  const fetchFiles = async () => {
    if (!relId || !relType) {
      setFiles([]);
      return;
    }

    setLoading(true);

    try {
      const response = await axios.get(`${API_BASE_CRM_URL}Files/GetFiles`, {
        params: {
          rel_id: relId,
          rel_type: relType,
        },
      });

      if (response.data?.Status) {
        setFiles(response.data.ResultData || []);
      } else {
        setFiles([]);
        message.error(response.data?.Message || "Failed to retrieve files.");
      }
    } catch (error) {
      console.error("GetFiles API error:", error);
      setFiles([]);
      message.error(
        error.response?.data?.Message || "Failed to load attachments.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, [relId, relType]);

  const isAudio = (file) =>
    file.filetype?.startsWith("audio/") ||
    /\.(mp3|wav|ogg|m4a|webm)$/i.test(file.file_name || "");

  const isImage = (file) =>
    file.filetype?.startsWith("image/") ||
    /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(file.file_name || "");

  const formatDate = (date) => {
    if (!date) return "—";

    const parsed = new Date(date);

    return Number.isNaN(parsed.getTime()) ? "—" : parsed.toLocaleString();
  };

  //   const downloadFile = async (file) => {
  //     if (!file.external_link) {
  //       message.error("Download URL is not available.");
  //       return;
  //     }

  //     setDownloadingId(file.id);

  //     try {
  //       // Download the file as a Blob.
  //       const response = await axios.get(file.external_link, {
  //         responseType: "blob",
  //       });

  //       const blobUrl = URL.createObjectURL(response.data);
  //       const anchor = document.createElement("a");

  //       anchor.href = blobUrl;
  //       anchor.download = file.file_name || "attachment";
  //       document.body.appendChild(anchor);
  //       anchor.click();
  //       anchor.remove();

  //       // Allow the browser time to start the download.
  //       setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  //     } catch (error) {
  //       console.error("Download error:", error);

  //       // Cross-origin storage may block Blob downloads through CORS.
  //       // Open the original URL as a fallback.
  //       window.open(file.external_link, "_blank", "noopener,noreferrer");

  //       message.warning(
  //         "Direct download was blocked. Opened the file link instead.",
  //       );
  //     } finally {
  //       setDownloadingId(null);
  //     }
  //   };

  const renderFilePreview = (file) => {
    if (isAudio(file)) {
      return (
        <div className="">
          {/* <div className="d-flex align-items-center mb-2">
            <AudioOutlined
              style={{
                fontSize: 20,
                color: "#1B2850",
                marginRight: 8,
              }}
            />
            <Text strong>Voice Recording</Text>
          </div> */}

          <audio
            controls
            preload="metadata"
            src={file.external_link}
            // style={{
            //   width: "100%",
            //   maxWidth: 450,
            //   display: "block",
            // }}
          >
            Your browser does not support audio playback.
          </audio>
        </div>
      );
    }

    if (isImage(file)) {
      return (
        <div className="mt-3">
          <Image
            src={file.external_link}
            alt={file.file_name}
            width={120}
            height={100}
            style={{
              objectFit: "cover",
              borderRadius: 8,
            }}
            preview
          />
        </div>
      );
    }

    return (
      <div className="mt-3 text-muted">
        <FileOutlined className="me-2" />
        Preview is not available for this file type.
      </div>
    );
  };

  return (
    <Base>
      <div className="page-header mb-3">
        <div className="row align-items-center mb-3">
          <div className="col-10">
            <div className="page-title mb-0">
              <h4 className="mb-0">View Task Attachments</h4>
            </div>
          </div>

          <div className="col-2 ms-auto">
            <Link to="/tasks" className="btn btn-secondary btn-sm">
              <i className="fa-solid fa-list"></i>
            </Link>
          </div>

          <div className="card table-list-card">
            <div className="card-body p-2 p-md-3">
              {loading ? (
                <div className="text-center my-5">
                  <div className="containers m-auto">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              ) : files.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <FileOutlined style={{ fontSize: 36 }} />
                  <p className="mt-2 mb-0">No files available</p>
                </div>
              ) : (
                <div>
                  {files.map((file) => (
                    <div
                      key={file.id}
                      className="p-2 p-md-3 rounded border mb-3"
                      style={{
                        backgroundColor: "#fff",
                        borderColor: "#e5e7eb",
                        overflow: "hidden",
                      }}
                    >
                      <div className="row g-3">
                        {/* File Information */}
                        <div className="col-12 col-lg-4">
                          <div className="d-flex align-items-start gap-2">
                            <div
                              className="d-flex align-items-center justify-content-center rounded flex-shrink-0"
                              style={{
                                width: 42,
                                height: 42,
                                backgroundColor: "#EAF4FF",
                              }}
                            >
                              {isAudio(file) ? (
                                <AudioOutlined
                                  style={{ fontSize: 21, color: "#1B2850" }}
                                />
                              ) : (
                                <FileOutlined
                                  style={{ fontSize: 21, color: "#1B2850" }}
                                />
                              )}
                            </div>

                            <div
                              className="flex-grow-1"
                              style={{ minWidth: 0 }}
                            >
                              <h6
                                className="mb-2 fw-semibold"
                                style={{
                                  color: "#1B2850",
                                  fontSize: 14,
                                  overflowWrap: "anywhere",
                                  lineHeight: 1.5,
                                }}
                              >
                                {file.file_name}
                              </h6>

                              <div
                                className="d-flex flex-wrap align-items-center gap-2 mb-1"
                                style={{
                                  fontSize: 12,
                                  overflowWrap: "anywhere",
                                }}
                              >
                                <span className="d-inline-flex align-items-center">
                                  <i className="fa-regular fa-user me-1 text-info"></i>
                                  {file.uploaded_by || "Unknown"}
                                </span>

                                <span className="d-inline-flex align-items-center">
                                  <i className="fa-regular fa-calendar text-primary me-1"></i>
                                  {formatDate(file.dateadded)}
                                </span>
                              </div>

                              {/* <div
                              className="text-muted"
                              style={{ fontSize: 12 }}
                            >
                              <i className="fa-regular fa-calendar me-1"></i>
                              {formatDate(file.dateadded)}
                            </div> */}
                            </div>
                          </div>
                        </div>

                        {/* File Preview */}
                        <div className="col-12">
                          <div
                          // className="rounded p-2 p-md-3"
                          // style={{
                          //   backgroundColor: "#f8f9fc",
                          //   minWidth: 0,
                          //   overflow: "hidden",
                          // }}
                          >
                            {renderFilePreview(file)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </Base>
  );
};

export default ViewTask;
